export default __webpack_public_path__ + "static/media/diameter.01c03542.svg";